enum eAdminUserRole {
  ParkAdmin = "park-admin",
  Admin = "admin",
  Manager = "manager",
  User = "user",
  UserNoRefund = "user-no-refund",
  ViewOnly = "view-only",
}

export default eAdminUserRole
